import { useMemo } from 'react'
import { usePathname } from 'next/navigation'

import { resolveQuickStartSlug } from '@/lib/github/tutorialSlug'
import type { TutorialSection } from '@/lib/github/types'
import { isDocumentationPath } from '@/shared/docs-shared.utils'

interface UseCurrentSectionPathParams {
  routePrefix: string
  sections: TutorialSection[]
  slugToPath?: (slugParts: string[]) => string | undefined
}

export function useCurrentSectionPath({ routePrefix, sections, slugToPath }: UseCurrentSectionPathParams) {
  const pathname = usePathname()

  return useMemo(() => {
    if (!pathname) return undefined

    if (routePrefix === '') {
      if (!isDocumentationPath(pathname)) return undefined

      const slugPart = pathname.slice(1)
      if (!slugPart) return undefined

      const slugParts = slugPart.split('/')
      return slugToPath?.(slugParts)
    }

    const prefix = `${routePrefix}/`
    if (!pathname.startsWith(prefix)) return undefined

    const slugPart = pathname.slice(prefix.length)
    if (!slugPart) return undefined

    const slugParts = slugPart.split('/')

    if (slugToPath) {
      return slugToPath(slugParts)
    }

    const resolved = resolveQuickStartSlug(slugParts, sections)
    return resolved?.articlePath
  }, [pathname, sections, routePrefix, slugToPath])
}
